import CollageConfiguratorTemplate from './CollageConfiguratorTemplate';

export default CollageConfiguratorTemplate;
